var map = {
	"./pages/admin/restaurant/restaurant.module.ngfactory": [
		"./src/app/pages/admin/restaurant/restaurant.module.ngfactory.js",
		"default~pages-admin-restaurant-restaurant-module-ngfactory~pages-admin-user-users-module-ngfactory~p~d193e392",
		"common",
		"pages-admin-restaurant-restaurant-module-ngfactory"
	],
	"./pages/admin/user/users.module.ngfactory": [
		"./src/app/pages/admin/user/users.module.ngfactory.js",
		"default~pages-admin-restaurant-restaurant-module-ngfactory~pages-admin-user-users-module-ngfactory~p~d193e392",
		"common",
		"pages-admin-user-users-module-ngfactory"
	],
	"./pages/order/order.module.ngfactory": [
		"./src/app/pages/order/order.module.ngfactory.js",
		"common",
		"pages-order-order-module-ngfactory"
	],
	"./pages/restaurants/restaurants.module.ngfactory": [
		"./src/app/pages/restaurants/restaurants.module.ngfactory.js",
		"default~pages-admin-restaurant-restaurant-module-ngfactory~pages-admin-user-users-module-ngfactory~p~d193e392",
		"common",
		"pages-restaurants-restaurants-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;